import React from 'react';
import { Route, RouteProps } from 'react-router';
import { Redirect } from 'react-router-dom';

import { PATH_ACCESS_FORBIDDEN } from './routes';
import { PermissionsType, useAuth } from '../app/AuthorizationProvider';

type ProtectedRouteProps = {
  component: React.ComponentType<any>;
  permissions?: PermissionsType[];
  requireAllPermissions?: boolean;
  customPermissionCheck?: () => boolean;
  [name: string]: any; // Allow additional props to be passed on components
} & RouteProps;

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  permissions,
  requireAllPermissions = true,
  customPermissionCheck,
  ...props
}) => {
  if (!permissions && !customPermissionCheck) {
    throw new Error('ProtectedRoute used without permissions or customPermissionCheck!');
  }

  const { userHasPermissions } = useAuth();
  const userHasRequiredPermissions = customPermissionCheck
    ? customPermissionCheck()
    : userHasPermissions(permissions, requireAllPermissions);

  return (
    <Route
      {...props}
      render={(routeProps) =>
        userHasRequiredPermissions ? (
          <Component {...routeProps} {...props} />
        ) : (
          <Redirect to={{ pathname: PATH_ACCESS_FORBIDDEN }} />
        )
      }
    />
  );
};
